/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function separateEvents(_ref) {
  var showEvent = _ref.showEvent,
    hideEvent = _ref.hideEvent;
  if (!Array.isArray(showEvent) || !Array.isArray(hideEvent)) {
    return {};
  }
  var normalizedShowEvents = (0, _toConsumableArray2.default)(showEvent);
  var normalizedHideEvents = (0, _toConsumableArray2.default)(hideEvent);
  var toggleEvents = [];
  normalizedShowEvents.forEach(function (eventName, index) {
    var searchIndex = normalizedHideEvents.indexOf(eventName);
    if (searchIndex !== -1) {
      toggleEvents.push(eventName);
      delete normalizedShowEvents[index];
      delete normalizedHideEvents[searchIndex];
    }
  });
  normalizedShowEvents = normalizedShowEvents.filter(function (eventName) {
    return eventName;
  });
  normalizedHideEvents = normalizedHideEvents.filter(function (eventName) {
    return eventName;
  });
  return {
    normalizedShowEvents: normalizedShowEvents,
    normalizedHideEvents: normalizedHideEvents,
    toggleEvents: toggleEvents
  };
}
var _default = separateEvents;
exports.default = _default;